<template>
  <page-not-found-view></page-not-found-view>
</template>

<script>
import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory";
export default {
  components: {
    PageNotFoundView: asyncComponentFactory(`views/general/PageNotFound.vue`, true),
  },
  layout: {
    component: "boxy",
    params: {},
  },
  meta: "core.404.metaTitle",
  data: function () {
    return {};
  },
};
</script>

<style scoped lang="scss"></style>
